import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import MaintenanceGuides from 'src/components/MaintenanceGuides/MaintenanceGuides';
import LoadState from 'src/components/LoadState/LoadState';
import { MaintenanceGuide } from 'src/SharedCustomHooks/UseMaintenanceGuides/types';

interface ItemMaintenanceGuideProps {
  item: any;
  maintenanceGuides: MaintenanceGuide[];
  loading: boolean;
  saveGuide: (guide: Partial<MaintenanceGuide>) => Promise<void>;
  updateGuide: (guide: MaintenanceGuide) => Promise<void>;
  deleteGuide: (guide: MaintenanceGuide) => Promise<void>;
  error: any;
  setSearchTerm: (term: string) => void;
  searchTerm: string;
}

const ItemMaintenanceGuide = ({
  item,
  maintenanceGuides,
  loading,
  saveGuide,
  updateGuide,
  deleteGuide,
  error,
  setSearchTerm,
  searchTerm,
}: ItemMaintenanceGuideProps) => {
  const user = useSelector(selectAuthenticatedUser);

  const handleSaveMaintenanceGuide = async (maintenanceGuide: any) => {
    if (maintenanceGuide.id) {
      await updateGuide({
        ...maintenanceGuide,
        itemId: item.id,
      });
    } else {
      await saveGuide({
        ...maintenanceGuide,
        author: {
          id: user.id,
          firstName: user.firstname,
          lastName: user.lastname,
        },
        createdAt: new Date().toISOString(),
      });
    }
  };

  const handleDeleteNote = async (guide: MaintenanceGuide) => {
    await deleteGuide(guide);
  };

  if (error) {
    return (
      <div className="error-state">
        <p>Failed to load maintenance reminders.</p>
        <button onClick={() => window.location.reload()}>Try Again</button>
      </div>
    );
  }

  return (
    <LoadState isLoading={loading}>
      <MaintenanceGuides
        from="Catalog"
        onlyView={user.roles[0].role.name === 'Strata Manager'}
        breadcrumb={item.name}
        maintenanceguides={maintenanceGuides}
        onSaveMaintenanceGuide={handleSaveMaintenanceGuide}
        onDeleteNote={(guide: any) =>
          handleDeleteNote({ ...guide, Type: 'MAINTENANCEGUIDE' })
        }
        onSearch={(e: any) => setSearchTerm(e.target.value.trim())}
        searchTerm={searchTerm}
      />
    </LoadState>
  );
};

export default ItemMaintenanceGuide;
